module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Dropdown 下拉按钮")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "60px"
    }
  }, [_c('section', {
    staticClass: "pull-left padding15"
  }, [_c('dropdown', {
    attrs: {
      "title": '下拉菜单',
      "menu": _vm.menu
    },
    on: {
      "choice": _vm.choice
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "pull-right padding15"
  }, [_c('dropdown', {
    attrs: {
      "title": '下拉菜单',
      "menu": _vm.menu,
      "right": true
    },
    on: {
      "choice": _vm.choice
    }
  })], 1)]), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("Html代码")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<!--菜单居左-->\n<dropdown :title=\"'下拉菜单'\" :menu=\"menu\" @choice=\"choice\"></dropdown>\n<!--菜单居右-->\n<dropdown :title=\"'下拉菜单'\" :menu=\"menu\" :right=\"true\" @choice=\"choice\"></dropdown>\n")])]), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("js代码")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v(" data() {\n  return {\n    menu: [\n      { value: 0, content: 'Action1' },\n      { value: 1, content: 'Action2' },\n      { value: 2, content: 'Action3' },\n      { value: 3, content: 'Action4' },\n      { value: 4, content: 'Action5', disabled: true },\n      { value: 5, content: 'Action6' }\n    ]\n  }\n},\nmethods: {\n  choice(val) {\n    this.$message({\n      caption: '成功',\n      content: `你选择了${this.menu[val].content}`,\n      type: 'info'\n    })\n  }\n}\n")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("Props 列表")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("Binding attributes 绑定属性")]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table striped hovered bordered border"
  }, [_c('thead', [_c('th', [_vm._v("Prop")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Required")]), _vm._v(" "), _c('th', [_vm._v("Default")]), _vm._v(" "), _c('th', [_vm._v("Description")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("title")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_vm._v("'Menu'")]), _vm._v(" "), _c('td', [_vm._v("按钮显示的文字")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("menu")]), _vm._v(" "), _c('td', [_vm._v("Array")]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("显示的菜单列表")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("right")]), _vm._v(" "), _c('td', [_vm._v("Boolean")]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("是否右侧对齐")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table striped hovered bordered border"
  }, [_c('thead', [_c('th', [_vm._v("Attribute Name")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Argument")]), _vm._v(" "), _c('th', [_vm._v("Description")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("choice")]), _vm._v(" "), _c('td', [_vm._v("Function")]), _vm._v(" "), _c('td', [_vm._v("n(选中项的value)")]), _vm._v(" "), _c('td', [_vm._v("选中菜单某一项后的回调事件")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c86891f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/dropdown-demo.vue
// module id = 408
// module chunks = 1